__turbopack_context__.v({
  "brandFilterCheckbox": "styles-module__PyYxwG__brandFilterCheckbox",
  "brandFilterContent": "styles-module__PyYxwG__brandFilterContent",
  "brandFilterDropdownContents": "styles-module__PyYxwG__brandFilterDropdownContents",
  "brandFilterDropdownHeading": "styles-module__PyYxwG__brandFilterDropdownHeading",
  "brandFilterNoResultsText": "styles-module__PyYxwG__brandFilterNoResultsText",
  "brandFilterSearchContainer": "styles-module__PyYxwG__brandFilterSearchContainer",
  "brandFilterSearchInput": "styles-module__PyYxwG__brandFilterSearchInput",
  "listContainer": "styles-module__PyYxwG__listContainer",
});
